/**
 * Ajustes do CRM (27/10, F3 e C9): textos do histórico em linha do tempo (`chatter.linha.*`, variante opt-in do Chatter).
 */
export const chatterLinhaPt = {
  exibir: 'Exibir',
  aplicar: 'Aplicar',
  tipos: { todos: 'Todos os eventos', alteracoes: 'Alterações', anotacoes: 'Anotações', tarefas: 'Tarefas', emails: 'E-mails' },
  nTipos_one: '{{count}} tipo',
  nTipos_other: '{{count}} tipos',
  criarAnotacao: 'Criar anotação',
  fecharAnotacao: 'Fechar anotação',
  fezAnotacao: 'fez uma anotação',
  enviouMensagem: 'enviou uma mensagem',
  excluirAnotacao: 'Excluir anotação',
  excluirTitulo: 'Excluir anotação?',
  excluirTexto: 'A anotação sai do histórico.',
  excluida: 'Anotação excluída',
  vazio: 'Nenhum evento para este filtro.',
  sistemaAutor: 'MalgoOS',
  /** Lista de 30/10 (B), item 21: o link do evento para o outro registro (a cópia da negociação). */
  abrirRegistro: 'Abrir',
  /** Item 22: o arquivo enviado entra na linha do tempo como evento ("<autor> anexou o arquivo <nome>"). */
  anexou: 'anexou o arquivo',
};

export const chatterLinhaEn: typeof chatterLinhaPt = {
  exibir: 'Show',
  aplicar: 'Apply',
  tipos: { todos: 'All events', alteracoes: 'Changes', anotacoes: 'Notes', tarefas: 'Tasks', emails: 'E-mails' },
  nTipos_one: '{{count}} type',
  nTipos_other: '{{count}} types',
  criarAnotacao: 'Create note',
  fecharAnotacao: 'Close note',
  fezAnotacao: 'wrote a note',
  enviouMensagem: 'sent a message',
  excluirAnotacao: 'Delete note',
  excluirTitulo: 'Delete note?',
  excluirTexto: 'The note leaves the history.',
  excluida: 'Note deleted',
  vazio: 'No events for this filter.',
  sistemaAutor: 'MalgoOS',
  abrirRegistro: 'Open',
  anexou: 'attached the file',
};

export const chatterLinhaEs: typeof chatterLinhaPt = {
  exibir: 'Mostrar',
  aplicar: 'Aplicar',
  tipos: { todos: 'Todos los eventos', alteracoes: 'Cambios', anotacoes: 'Anotaciones', tarefas: 'Tareas', emails: 'Correos' },
  nTipos_one: '{{count}} tipo',
  nTipos_other: '{{count}} tipos',
  criarAnotacao: 'Crear anotación',
  fecharAnotacao: 'Cerrar anotación',
  fezAnotacao: 'hizo una anotación',
  enviouMensagem: 'envió un mensaje',
  excluirAnotacao: 'Eliminar anotación',
  excluirTitulo: '¿Eliminar anotación?',
  excluirTexto: 'La anotación sale del historial.',
  excluida: 'Anotación eliminada',
  vazio: 'No hay eventos para este filtro.',
  sistemaAutor: 'MalgoOS',
  abrirRegistro: 'Abrir',
  anexou: 'adjuntó el archivo',
};
